import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ServicePopup } from './ServicePopup';

import { ServiceItem, serviceItems, ServiceType } from '@/data/service-items';
import { translate } from '@/translations';
import { logServicesDialogOpen } from '@/utils/analytics-utils';

export const ServicesSection = () => {
  const { t } = useTranslation('services');

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<ServiceItem>(serviceItems[0]);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [location]);

  const openServiceDialog = (serviceItem: ServiceItem) => {
    setSelectedService(serviceItem);
    setDialogOpen(true);
    logServicesDialogOpen(serviceItem.type);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <div className="section bg-dark text-white rounded-t-lg">
      <div className="md:sticky top-0 bg-dark py-4 text-center z-20">
        <h1 className="section-title">{t('services')}</h1>
      </div>

      <div className="flex flex-col items-center gap-24 mt-8">
        {serviceItems.map((serviceItem, index) => {
          if (index % 2 === 0) {
            return (
              <div
                id={serviceItem.id}
                key={serviceItem.type}
                className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-4/6"
              >
                <div>
                  <div className="md:sticky top-16 self-start section-title2 !text-white py-8 blur-bottom-dark">
                    {translate(serviceItem.titleKey)}
                  </div>
                  <div className="section-content !text-white">
                    {translate(serviceItem.descriptionKey)}
                  </div>

                  <div className="mt-8">
                    <button
                      onClick={() => openServiceDialog(serviceItem)}
                      className="action-button hover:bg-[#49E78F]"
                    >
                      {t('learnMore')}
                    </button>
                    <ServicePopup
                      open={dialogOpen}
                      onClose={handleClose}
                      serviceItem={selectedService}
                    />
                  </div>
                </div>
                <div className="flex justify-center items-center">
                  <img
                    loading="lazy"
                    src={serviceItem.serviceImage}
                    alt={translate(serviceItem.titleKey)}
                  />
                </div>
              </div>
            );
          } else {
            return (
              <div
                id={serviceItem.id}
                key={serviceItem.type}
                className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-4/6"
              >
                <div className="flex justify-center items-center">
                  <img
                    loading="lazy"
                    src={serviceItem.serviceImage}
                    alt={translate(serviceItem.titleKey)}
                  />
                </div>
                <div>
                  <div className="md:sticky top-16 self-start section-title2 !text-white py-8 blur-bottom-dark">
                    {translate(serviceItem.titleKey)}
                  </div>
                  <div className="section-content !text-white">
                    {translate(serviceItem.descriptionKey)}
                  </div>

                  <div className="mt-8">
                    <button
                      onClick={() => openServiceDialog(serviceItem)}
                      className="action-button hover:bg-[#49E78F]"
                    >
                      {t('learnMore')}
                    </button>
                    <ServicePopup
                      open={dialogOpen}
                      onClose={handleClose}
                      serviceItem={selectedService}
                    />
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};
